module.exports = __webpack_public_path__ + "img/Unable-to-Delete-Role.a3b80122.svg";